export const iconFontAwesomeSecurityPersonMilitaryToPerson = (
	<i className="fa-solid fa-person-military-to-person"></i>
);
